/** Block type used by the in-editor "Import structure" placeholder. */
export const IMPORT_STRUCTURE_TYPE = "ImportStructure";

/**
 * Studio-only component types that must not be exposed to AI imports, the block
 * reference, or the public block catalog. They exist purely as editor tooling.
 */
export const INTERNAL_STUDIO_COMPONENT_TYPES = new Set<string>([
  IMPORT_STRUCTURE_TYPE,
]);

export function isInternalStudioComponentType(type: string): boolean {
  return INTERNAL_STUDIO_COMPONENT_TYPES.has(type);
}

export function getImportStructureLabel(): string {
  return "Import structure";
}
